import React from 'react';
import { Row } from 'react-bootstrap';

import { StampUploadSection } from './StampUploadSection';

interface StampDisplayProps {
  bigStamp: string;
  setBigStamp: (file: string) => void;
  smallStamp: string;
  setSmallStamp: (file: string) => void;
  doubleStamp: string;
  setDoubleStamp: (file: string) => void;
  signatureStamp: string;
  setSignatureStamp: (file: string) => void;
}

export const StampDisplay: React.FC<StampDisplayProps> = ({
  bigStamp,
  setBigStamp,
  smallStamp,
  setSmallStamp,
  doubleStamp,
  setDoubleStamp,
  signatureStamp,
  setSignatureStamp,
}) => {
  return (
    <Row>
      <StampUploadSection
        title="Pieczątka duża"
        file={bigStamp}
        setFile={setBigStamp}
        buttonText="Wgraj pieczątkę dużą"
      />

      <StampUploadSection
        title="Pieczątka mała"
        file={smallStamp}
        setFile={setSmallStamp}
        buttonText="Wgraj pieczątkę małą"
      />

      <StampUploadSection
        title="Pieczątka podwójna"
        file={doubleStamp}
        setFile={setDoubleStamp}
        buttonText="Wgraj pieczątkę podwójną"
      />

      <StampUploadSection
        title="Podpis"
        file={signatureStamp}
        setFile={setSignatureStamp}
        buttonText="Wgraj podpis"
      />
    </Row>
  );
};
